<template>
  <ChecklistBlockBase
    :buttonsData="editorMetadata.buttonsData"
    :buttonsPreset="'copy'"
    @commonAction="(action) => $emit('commonAction', action)"
  >
    <WhiteIQOS noOverflow bodyClass="checklist-block-iqos-body">
      <template #title>
        <BaseIcon size="sm3" icon="list-bold" /> <div>{{ $t('checklist_blocks.options.title') }}</div>
      </template>

      <div class="checklist-block-iqos-body-block">
        <BaseTextInput v-model="block.title" size="md" :placeholder="$t('checklist_blocks.title_ph')" />
      </div>

      <BaseDivider color="border-base-tertiary" />

      <div class="the-options-block-list">
        <template v-for="(row, index) in block.options.rows">
          <div class="block-list-item" :key="index">
            <BaseTextInput
              size="md"
              v-model="row.text"
              @blur="$emit('commonAction', 'update')"
              :placeholder="`${$t('checklist_blocks.options.item_ph')} ${index + 1}`"
              @enterPress="addItem"
            />
            <BaseNumberInput
              size="md"
              v-model.number="row.score"
              @blur="$emit('commonAction', 'update')"
              :placeholder="$t('checklist_blocks.options.score_ph')"
              class="score-input"
              v-if="block.options.scored"
            />
            <BaseIconButton
              variant="ghost"
              icon="x"
              size="sm"
              @click="removeItem(index)"
              textColor="content-base-tertiary"
            />
          </div>
          <BaseDivider color="border-base-tertiary" :key="`div${index}`" />
        </template>

        <!-- <draggable :value="block.options.rows" @change="onRearrangeChange">
          <template v-for="(row, index) in block.options.rows">

            <BaseDivider color="border-base-tertiary" :key="`div${index}`" />
          </template>
        </draggable> -->
        <div class="add-button-container">
          <BasePushButton
            @click="addItem"
            icon="plus"
            size="md"
            variant="ghost"
          >
            {{ $t('checklist_blocks.options.btn_add') }}
          </BasePushButton>
        </div>
      </div>

      <template #footer>
        <div class="checklist-block-iqos-footer">
          <div class="gap-row-xs">
            <div class="qrw-label-lg qrw-text-content-base-primary">
              {{ $t('checklist_blocks.options.display_as') }}
            </div>
            <div class="gap-column-sm">
              <BaseBetaRadioButton
                :value="block.options.display_mode === 'dropdown'"
                @input="block.options.display_mode = 'dropdown'"
              >
                {{ $t('checklist_blocks.options.as_dropdown')}}
              </BaseBetaRadioButton>

              <BaseBetaRadioButton
                :value="block.options.display_mode === 'buttons'"
                @input="block.options.display_mode = 'buttons'"
              >
                {{ $t('checklist_blocks.options.as_buttons')}}
              </BaseBetaRadioButton>
            </div>
          </div>
        </div>
        <BaseDivider color="border-base-secondary" />
        <BlockAssignOption
          :block="block"
          :optionsBlocks="editorMetadata.optionsBlocksAbove"
          @assigned="$emit('commonAction', 'update')"
          v-if="editorMetadata.canAssignOptions"
        />
        <BaseDivider
          color="border-base-secondary"
          v-if="editorMetadata.canAssignOptions"
        />
        <CommonBlockSettings @update="$emit('commonAction', 'update')" :block="block"/>
      </template>
    </WhiteIQOS>
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";
import { nanoid } from "nanoid";
import BlockAssignOption from "../BlockAssignOption.vue";
import CommonBlockSettings from "../CommonBlockSettings.vue"

export default {
  props: {
    block: Object,
    editorMetadata: Object,
  },
  data() {
    return {};
  },
  methods: {
    addItem() {
      this.block.options.rows.push({
        text: null,
        option_id: nanoid(16),
      });
    },
    removeItem(index) {
      this.$delete(this.block.options.rows, index);

      this.$emit('commonAction', 'update');
    },
  },
  mounted() {},
  components: {
    ChecklistBlockBase,
    BlockAssignOption,
    CommonBlockSettings
  },
};
</script>

<style scoped>
.the-options-block-list {
  display: flex;
  flex-direction: column;
  padding: 16px;
  row-gap: 8px;
}

.block-list-item {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
}

.add-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.long-options {
  flex-direction: column;
  row-gap: 12px;
  justify-content: flex-start;
  align-items: flex-start;
}

.score-input {
  width: 200px;
}
</style>
